import NotificationUtil from "./_notificationUtil";
import Modal from "./_bootstrapModalExtensions";
import Interfaces from "./_interfaces";
import * as GAUtil from './_google_analytics';

import * as Layout from "./Utils/LayoutUtil";
import * as Url from "./Utils/UrlUtil";

import * as Intro from "./Intros/_IntroBase";
import * as SettlementFilterIntro from './Intros/_settlementFilter';

import * as DxFilter from "./_devexpressFilter";
import * as DxFilterDate from "./_dateFilterPanel";

const ProcessListBaseFilterSettingName: string = "ProcessList-BaseFilter-Value";
const ProcessListFilterSwitchSettingName: string = "ProcessList-FilterSwitch-Value";

function InitFilters() {
    DxFilter.InitFavoriteSettlementFilter(ProcessListFilterSwitchSettingName);
}

function SetFilterVisibility(displayDateAndSettlementFilter: boolean) {
    DxFilterDate.SetDateFilterSectionVisibility(displayDateAndSettlementFilter);

    DxFilter.LoadFavoriteSettlementFilterValueFromSettings(displayDateAndSettlementFilter, ProcessListFilterSwitchSettingName);
    DxFilter.SetFavoriteSettlementFilterVisibility(displayDateAndSettlementFilter);
}

export function ProcessListOnInit(s: MVCxClientGridView, e: ASPxClientEventArgs) {
    let baseFilter: JQuery = $('#BaseFilter');
    let haveToStoreView: boolean = $('#BaseFilter').attr('data-have-to-store-view') === 'True';

    if (haveToStoreView) {
        let view: string = window.SettingsManager.getAttribute(ProcessListBaseFilterSettingName);

        if (view) {
            baseFilter.val(view);
        }
    }
    s.Init
    InitFilters();

    let baseFilterValue: string = $('#BaseFilter option:selected').val() as string;
    let displayDateAndSettlementFilter: boolean = ShouldDisplayDateAndSettlementFilter(baseFilterValue);

    SetFilterVisibility(displayDateAndSettlementFilter);

    s.Refresh();

    if (displayDateAndSettlementFilter && Layout.IsOnGreenSide()) {
        Intro.AutoRunIntro(() => SettlementFilterIntro.settlementFilterAutoStart(), 'settlementFilterIntro');
    }
}

export function ProcessListOnBeginCallback(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    DxFilterDate.CheckAndCorrectDateFilterValues();

    // Additional parameters are loaded from the fields directly each time DX performs a callback
    let baseFilter: string = $('.bf-element').val() as string;
    let processNumber: string = $('.pn-element').val() as string;
    let filingNumber: string = $('.fn-element').val() as string;
    let quickFilterId: string = $('.qf-element').val() as string;
    let quickFilterValue: string = $('.qfv-element').val() as string;
    let filterForFavoriteSettlements: boolean = $('#favorite-settlements-switch:checkbox').is(':checked');
    let topoNumberFilterValueForSystemUser: string = $('.toponumber-value').val() as string;
    let settlementFilterValueForSystemUser: string = $('.settlement-value').val() as string;
    let processNumberFilterValueForSystemUser: string = $('.processnumber-value').val() as string;

    e.customArgs['baseFilter'] = baseFilter;
    e.customArgs['processNumberValue'] = processNumber;
    e.customArgs['filingSystemNumberValue'] = filingNumber;
    e.customArgs['quickFilterId'] = quickFilterId;
    e.customArgs['quickFilterValue'] = quickFilterValue;
    e.customArgs['filterForFavoriteSettlements'] = filterForFavoriteSettlements;
    e.customArgs['topoNumberfilterForSystemUser'] = topoNumberFilterValueForSystemUser;
    e.customArgs['settlementfilterForSystemUser'] = settlementFilterValueForSystemUser;
    e.customArgs['processNumberfilterForSystemUser'] = processNumberFilterValueForSystemUser;

    let needToFilterByDate: boolean = $('#date-filter-area').is(':visible');

    if (needToFilterByDate) {
        let fromDate: string = $('.dfflt-from').val() as string;
        let toDate: string = $('.dfflt-to').val() as string;

        e.customArgs['fromDate'] = fromDate;
        e.customArgs['toDate'] = toDate;
    }
}

export function ProcessListOnEndCallback(s: Interfaces.MVCxClientGridViewWithCustomProperties, e: MVCxClientBeginCallbackEventArgs) {
    // Display filter alert if necessary
    DxFilter.ToggleAlertVisibilityForProcessAndFilingList(s);

    WarnClerkAboutUnfinishedKshForm(s);
}

export function ProcessListOnBeginCallbackBlue(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    let baseFilter: string = $('.process-basefilter-blue').val() as string;
    e.customArgs['baseFilter'] = baseFilter;
}

export function RefreshProcessListBlue() {
    var grid = window['ProcessListByUser'] as MVCxClientGridView;
    grid.Refresh();
}

export function SendFilterExpressionToAnalytics(s, e) {

    var view = "@view";
    var eventAction = "";

    if (view === "DRAFT")
        eventAction = "Piszkozatok";

    if (view === "PRELIMINARY")
        eventAction = "Előzetes megkeresések";

    if (view === "SUBMITTED")
        eventAction = "Beadott kérelmek";

    // A keresett kifejezés
    var filterExpression = s.filterHelper.savedSearchEditorValue_beforeCallback;
    GAUtil.SendEventToAnalytics('Keresés', eventAction, filterExpression);
}

export function OnBaseFilterChangedOnProcessList() {

    let baseFilter: JQuery = $('#BaseFilter');
    let baseFilterValue: string = $('#BaseFilter option:selected').val() as string;
    let haveToStoreView: boolean = baseFilter.attr('data-have-to-store-view') === 'True';
    let displayDateAndSettlementFilter: boolean = ShouldDisplayDateAndSettlementFilter(baseFilterValue);

    SetFilterVisibility(displayDateAndSettlementFilter);

    if (haveToStoreView) {
        window.SettingsManager.setAttribute(ProcessListBaseFilterSettingName, baseFilter.val());
    }

    let grid: MVCxClientGridView = window['ProcessListByOffice'] as MVCxClientGridView;
    grid.Refresh();

    if (displayDateAndSettlementFilter && Layout.IsOnGreenSide()) {
        Intro.AutoRunIntro(() => SettlementFilterIntro.settlementFilterAutoStart(), 'settlementFilterIntro');
    }
}

function ShouldDisplayDateAndSettlementFilter(baseFilterValue: string): boolean {
    return baseFilterValue === "HatosagFolyamatban"
        || baseFilterValue === "UgyintezoSajat"
        || baseFilterValue === "Hatosag";
}

export function DeleteFormerProcess(event: JQuery.TriggeredEvent) {
    let $button: JQuery<HTMLElement> = $(event.target).parent();

    Modal.showConfirmationWindowAsync(
        'Biztosan törölni szeretné az előzményt?',
        'Megerősítés',
        () => { deleteFormerProcess($button); },
        () => { return false; },
        'Igen',
        'Nem');

    function deleteFormerProcess($button: JQuery<HTMLElement>) {
        let processId: number = $button.data('processid') as number;
        let formerProcessId: number = $button.data('former-processid') as number;
        let $errorSection: JQuery<HTMLElement> = $('#error-display');

        $errorSection.hide();

        $button.prop('disabled', false);

        $.ajax({
            method: 'POST',
            url: window.ETDR_RD.appConfig['UrlAction.DeleteFormerProcess'],
            data: {
                processId: processId,
                formerProcessId: formerProcessId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data) => {
                if (data.success) {
                    let grid: MVCxClientGridView = window['listFormerProcessesModel'] as MVCxClientGridView;
                    grid.Refresh();
                } else {
                    $errorSection.text(data.message).show();
                }
            })
            .fail((jqXHR: JQueryXHR) => {
                // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
                $errorSection.html(jqXHR.responseText);
                $errorSection.show();
            })
            .always(() => {
                $button.prop('disabled', false);
            });
    }
}

export function InitEventsInRelatedProcessesTable() {
    $('.delete-former-process-btn').on('click', (event) => DeleteFormerProcess(event));
}

export function OnRowClickProcess(s: ASPxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    let htmlEvent = e.htmlEvent as Event;
    let target = htmlEvent.target as Element;

    if (target.classList.contains('dxgvCommandColumn_ETDRTheme')
        || target.parentElement.classList.contains('dxgvCommandColumn_ETDRTheme')) {
        return;
    }

    // If the expand button "+" was clicked, consider this event handled and bail
    //if (ExpandDetailRowOnCellClick(s, e)) {
    //    return;
    //}

    let key: string = s.GetRowKey(e.visibleIndex);

    if (key !== null) {
        let urlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.ProcessEdit'];
        let url: string = Url.createUrlFromTemplate(urlTemplate, { Id: key });

        window.open(url, '_blank');
    }
}

// Clicks on the detail button should be handled by a different event handler
// Return truthy if the event was handled
let isDetailRowExpanded: any[] = new Array();
export function ExpandDetailRowOnCellClick(s: ASPxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    /* TODO:
     * This code is intentionaly commented out
     * There is currently a bug in DevExpress (or a not supported feature working "strangely")
     * which causes the ExpandDetailRow to multiply (1-2-4-8 etc) in executions (yes, really)
     * Until that is fixed (most likely by upgrading to the latest version) this feature is disabled */
    //let htmlEvent = e.htmlEvent as Event;
    //let target = htmlEvent.target as Element;

    //if (target.classList.contains('dxgvDetailButton_ETDRTheme')) {

    //    if (isDetailRowExpanded[e.visibleIndex] !== true) {
    //        isDetailRowExpanded[e.visibleIndex] = true;
    //        s.ExpandDetailRow(e.visibleIndex);
    //    }
    //    else {
    //        isDetailRowExpanded[e.visibleIndex] = false;
    //        s.CollapseDetailRow(e.visibleIndex);
    //    }

    //    return true;
    //}

    //return false;
}

export function RefreshInspectorsTable(processId) {
    let urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.GetInspectorsForProcess"];
    let url: string = Url.createUrlFromTemplate(urlTemplate, { processId: processId });

    $('#shared-with-' + processId).load(url);
}

export function OnProcessEditButtonClickedOnProcessList() {
    let processId: string = getSelectedKeyFromProcessList();

    if (!processId) {
        NotificationUtil.Warning('Nincs eljárás kiválasztva!');
        return;
    }

    let urlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.ProcessEdit'];
    let url: string = Url.createUrlFromTemplate(urlTemplate, { Id: processId });

    location.href = url;
}

export function OnProcessDeleteButtonClickedOnProcessList() {
    let processId: string = getSelectedKeyFromProcessList();

    if (!processId) {
        NotificationUtil.Warning('Nincs eljárás kiválasztva!');
        return;
    }

    Modal.showConfirmationWindowAsync(
        'Biztosan törli a kiválasztott eljárást?',
        'Törlés megerősítése',
        () => { deleteProcessByOfficeClerk(processId) },
        () => { },
        'Igen',
        'Nem'
    );
}

function deleteProcessByOfficeClerk(processId: string) {
    let url: string = window.ETDR_RD.appConfig['UrlAction.DeleteProcess'];

    $.ajax({
        method: 'POST',
        url: url,
        data: { 'processId': processId },
        headers: { Accept: 'application/json' }
    })
        .done((response: Interfaces.EphatFilterResponse) => {
            if (response.success) {
                NotificationUtil.Info('Az eljárás törlése sikeres');

                let grid: MVCxClientGridView = window['ProcessListByOffice'] as MVCxClientGridView;
                grid.Refresh();
            } else {
                let errorText: string;

                if (response.message) {
                    errorText = response.message;
                } else {
                    errorText = 'Hiba történt a dokumentum állapotának ellenőrzése során.';
                }

                NotificationUtil.Error(errorText);
            }

        })
        .fail((jqXHR) => {
            let message: string;

            if (jqXHR.responseText) {
                message = jqXHR.responseText;
            } else {
                message = 'Hiba történt a kérés során. Kérjük, töltse újra az oldalt!';
            }

            NotificationUtil.Error(message, 'Hiba');
        });
}

function getSelectedKeyFromProcessList(): string {
    let grid: MVCxClientGridView = window['ProcessListByOffice'] as MVCxClientGridView;

    return grid.GetSelectedKeysOnPage()[0];
}

function WarnClerkAboutUnfinishedKshForm(grid: Interfaces.MVCxClientGridViewWithCustomProperties) {
    const needToWarnUserAboutUnfinishedKshForm: boolean = grid.cpNeedToWarnUserAboutUnfinishedKshForm;

    if (needToWarnUserAboutUnfinishedKshForm) {
        const contentHtml: string = '<div>Tisztelt Ügyintéző! A <i class="icon-ico-form-error text-danger"></i> jellel megjelölt egyszerű bejelentéseknél teendője van a KSH felé teljesítendő adatszolgáltatás kapcsán! Legyen szíves a Statisztika Tab-on véglegesítse az adatokat, vagy jelölje meg, hogy nem kell adatot szolgáltatni a KSH felé!</div>';
        NotificationUtil.Warning(contentHtml, 'Befejezetlen statisztika');
    }
}

jQuery(() => {
    $('.bf-element').on('change', () => OnBaseFilterChangedOnProcessList());

    $('.process-basefilter-blue').on('change', () => RefreshProcessListBlue());

    $('[data-toggle="tooltip"]').tooltip();

    $(document).on('blur', '.clerkprocessstate-editor', (event: JQuery.BlurEvent) => {
        let $select = $(event.target) as JQuery<HTMLSelectElement>;

        let processId = $select.data('processid');
        let stateId = $select.val();

        $.post({
            url: window.ETDR_RD.appConfig['UrlAction.UpdateClerkProcessState'],
            dataType: "json",
            data: {
                processId: processId,
                stateId: stateId
            },
        }).fail((jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) => {
            NotificationUtil.Error(jqXHR.responseJSON.message, 'Sikertelen mentés');
        });
    });

    $(document).on('click', '#ProcessEditButton', () => { OnProcessEditButtonClickedOnProcessList(); });

    $(document).on('click', '#ProcessDeleteButton', () => { OnProcessDeleteButtonClickedOnProcessList(); });
});
